// Local Storage keys
export const AccessTokenKey = 'accessToken';
export const DateFormat = 'DD/MM/YY';
export const DateFormatWithHours = 'DD/MM/YY HH:mm';

// Auth
export const AuthGetAdminRoleArray = 'https://jm-iot-api/roles';

//App Config
export const TeracomBaseUrl = process.env.REACT_APP_TERACOM_BASE_URL;
export const ApiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const BrandName = process.env.REACT_APP_CUSTOMER_BRAND;
export const InsightsKey = process.env.REACT_APP_INSIGHTS_KEY;
export const ApiDMI = process.env.REACT_APP_API_DMI_BASE;
